import React from "react";
import PageWithHistory from "../../../helpers/page-with-history";
import HistoryTable from "./table";

const History = props => (
  <PageWithHistory title="Your History" dataComponent={HistoryTable} />
);

export default History;
